export type AtsCause = {
  cause: string;
  probability: number;
};

export type AtsFault = {
  id: string;
  category_id: string | null;
  device_ar: string;
  name_ar: string;
  description_ar: string;
  symptoms: string[];
  causes: AtsCause[];
  tests: {
    test: string;
    location: string;
    method: string;
    normal: string;
    faulty: string;
  }[];
  solutions: string[];
  severity: string;
  safety_warnings: string[];
  error_code: string | null;
  keywords: string;
  next_question_key: string | null;
};

type Row = [
  string,
  string,
  string,
  string,
  string,
  AtsCause[],
  string[],
  string,
  string
];

const C = (cause: string, probability: number): AtsCause => ({
  cause,
  probability,
});

const rows: Row[] = [
[
  "ats-001",
  "دخل المصدر الرئيسي",
  "دخل المصدر الرئيسي ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة دخل المصدر الرئيسي متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة دخل المصدر الرئيسي",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "ATS / Changeover mains source not working open",
],
[
  "ats-002",
  "دخل المصدر الرئيسي",
  "حرارة دخل المصدر الرئيسي ترتفع",
  "حرارة دخل المصدر الرئيسي أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة دخل المصدر الرئيسي",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "ATS / Changeover mains source overheating hot",
],
[
  "ats-003",
  "دخل المصدر الرئيسي",
  "دخل المصدر الرئيسي يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة دخل المصدر الرئيسي تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "ATS / Changeover mains source intermittent unstable",
],
[
  "ats-004",
  "دخل المصدر الرئيسي",
  "دخل المصدر الرئيسي بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ دخل المصدر الرئيسي.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "ATS / Changeover mains source loose wrong connection",
],
[
  "ats-005",
  "دخل المصدر الرئيسي",
  "قراءة أو خرج دخل المصدر الرئيسي مو طبيعي",
  "قراءة أو خرج دخل المصدر الرئيسي أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "ATS / Changeover mains source abnormal reading output",
],
[
  "ats-006",
  "دخل المولد",
  "دخل المولد ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة دخل المولد متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة دخل المولد",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "ATS / Changeover generator source not working open",
],
[
  "ats-007",
  "دخل المولد",
  "حرارة دخل المولد ترتفع",
  "حرارة دخل المولد أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة دخل المولد",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "ATS / Changeover generator source overheating hot",
],
[
  "ats-008",
  "دخل المولد",
  "دخل المولد يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة دخل المولد تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "ATS / Changeover generator source intermittent unstable",
],
[
  "ats-009",
  "دخل المولد",
  "دخل المولد بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ دخل المولد.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "ATS / Changeover generator source loose wrong connection",
],
[
  "ats-010",
  "دخل المولد",
  "قراءة أو خرج دخل المولد مو طبيعي",
  "قراءة أو خرج دخل المولد أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "ATS / Changeover generator source abnormal reading output",
],
[
  "ats-011",
  "كونتاكتور المصدر الرئيسي",
  "كونتاكتور المصدر الرئيسي ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة كونتاكتور المصدر الرئيسي متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة كونتاكتور المصدر الرئيسي",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "ATS / Changeover mains contactor not working open",
],
[
  "ats-012",
  "كونتاكتور المصدر الرئيسي",
  "حرارة كونتاكتور المصدر الرئيسي ترتفع",
  "حرارة كونتاكتور المصدر الرئيسي أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة كونتاكتور المصدر الرئيسي",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "ATS / Changeover mains contactor overheating hot",
],
[
  "ats-013",
  "كونتاكتور المصدر الرئيسي",
  "كونتاكتور المصدر الرئيسي يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة كونتاكتور المصدر الرئيسي تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "ATS / Changeover mains contactor intermittent unstable",
],
[
  "ats-014",
  "كونتاكتور المصدر الرئيسي",
  "كونتاكتور المصدر الرئيسي بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ كونتاكتور المصدر الرئيسي.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "ATS / Changeover mains contactor loose wrong connection",
],
[
  "ats-015",
  "كونتاكتور المصدر الرئيسي",
  "قراءة أو خرج كونتاكتور المصدر الرئيسي مو طبيعي",
  "قراءة أو خرج كونتاكتور المصدر الرئيسي أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "ATS / Changeover mains contactor abnormal reading output",
],
[
  "ats-016",
  "كونتاكتور المولد",
  "كونتاكتور المولد ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة كونتاكتور المولد متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة كونتاكتور المولد",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "ATS / Changeover generator contactor not working open",
],
[
  "ats-017",
  "كونتاكتور المولد",
  "حرارة كونتاكتور المولد ترتفع",
  "حرارة كونتاكتور المولد أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة كونتاكتور المولد",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "ATS / Changeover generator contactor overheating hot",
],
[
  "ats-018",
  "كونتاكتور المولد",
  "كونتاكتور المولد يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة كونتاكتور المولد تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "ATS / Changeover generator contactor intermittent unstable",
],
[
  "ats-019",
  "كونتاكتور المولد",
  "كونتاكتور المولد بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ كونتاكتور المولد.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "ATS / Changeover generator contactor loose wrong connection",
],
[
  "ats-020",
  "كونتاكتور المولد",
  "قراءة أو خرج كونتاكتور المولد مو طبيعي",
  "قراءة أو خرج كونتاكتور المولد أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "ATS / Changeover generator contactor abnormal reading output",
],
[
  "ats-021",
  "Motorized Changeover",
  "Motorized Changeover ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة Motorized Changeover متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة Motorized Changeover",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "ATS / Changeover motorized changeover not working open",
],
[
  "ats-022",
  "Motorized Changeover",
  "حرارة Motorized Changeover ترتفع",
  "حرارة Motorized Changeover أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة Motorized Changeover",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "ATS / Changeover motorized changeover overheating hot",
],
[
  "ats-023",
  "Motorized Changeover",
  "Motorized Changeover يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة Motorized Changeover تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "ATS / Changeover motorized changeover intermittent unstable",
],
[
  "ats-024",
  "Motorized Changeover",
  "Motorized Changeover بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ Motorized Changeover.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "ATS / Changeover motorized changeover loose wrong connection",
],
[
  "ats-025",
  "Motorized Changeover",
  "قراءة أو خرج Motorized Changeover مو طبيعي",
  "قراءة أو خرج Motorized Changeover أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "ATS / Changeover motorized changeover abnormal reading output",
],
[
  "ats-026",
  "ATS Controller",
  "ATS Controller ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة ATS Controller متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة ATS Controller",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "ATS / Changeover ats controller not working open",
],
[
  "ats-027",
  "ATS Controller",
  "حرارة ATS Controller ترتفع",
  "حرارة ATS Controller أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة ATS Controller",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "ATS / Changeover ats controller overheating hot",
],
[
  "ats-028",
  "ATS Controller",
  "ATS Controller يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة ATS Controller تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "ATS / Changeover ats controller intermittent unstable",
],
[
  "ats-029",
  "ATS Controller",
  "ATS Controller بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ ATS Controller.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "ATS / Changeover ats controller loose wrong connection",
],
[
  "ats-030",
  "ATS Controller",
  "قراءة أو خرج ATS Controller مو طبيعي",
  "قراءة أو خرج ATS Controller أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "ATS / Changeover ats controller abnormal reading output",
],
[
  "ats-031",
  "حساس فولت المصدر الرئيسي",
  "حساس فولت المصدر الرئيسي ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة حساس فولت المصدر الرئيسي متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة حساس فولت المصدر الرئيسي",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "ATS / Changeover mains sensing not working open",
],
[
  "ats-032",
  "حساس فولت المصدر الرئيسي",
  "حرارة حساس فولت المصدر الرئيسي ترتفع",
  "حرارة حساس فولت المصدر الرئيسي أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة حساس فولت المصدر الرئيسي",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "ATS / Changeover mains sensing overheating hot",
],
[
  "ats-033",
  "حساس فولت المصدر الرئيسي",
  "حساس فولت المصدر الرئيسي يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة حساس فولت المصدر الرئيسي تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "ATS / Changeover mains sensing intermittent unstable",
],
[
  "ats-034",
  "حساس فولت المصدر الرئيسي",
  "حساس فولت المصدر الرئيسي بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ حساس فولت المصدر الرئيسي.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "ATS / Changeover mains sensing loose wrong connection",
],
[
  "ats-035",
  "حساس فولت المصدر الرئيسي",
  "قراءة أو خرج حساس فولت المصدر الرئيسي مو طبيعي",
  "قراءة أو خرج حساس فولت المصدر الرئيسي أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "ATS / Changeover mains sensing abnormal reading output",
],
[
  "ats-036",
  "حساس فولت المولد",
  "حساس فولت المولد ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة حساس فولت المولد متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة حساس فولت المولد",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "ATS / Changeover generator sensing not working open",
],
[
  "ats-037",
  "حساس فولت المولد",
  "حرارة حساس فولت المولد ترتفع",
  "حرارة حساس فولت المولد أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة حساس فولت المولد",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "ATS / Changeover generator sensing overheating hot",
],
[
  "ats-038",
  "حساس فولت المولد",
  "حساس فولت المولد يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة حساس فولت المولد تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "ATS / Changeover generator sensing intermittent unstable",
],
[
  "ats-039",
  "حساس فولت المولد",
  "حساس فولت المولد بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ حساس فولت المولد.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "ATS / Changeover generator sensing loose wrong connection",
],
[
  "ats-040",
  "حساس فولت المولد",
  "قراءة أو خرج حساس فولت المولد مو طبيعي",
  "قراءة أو خرج حساس فولت المولد أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "ATS / Changeover generator sensing abnormal reading output",
],
[
  "ats-041",
  "حساس التردد",
  "حساس التردد ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة حساس التردد متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة حساس التردد",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "ATS / Changeover frequency sensing not working open",
],
[
  "ats-042",
  "حساس التردد",
  "حرارة حساس التردد ترتفع",
  "حرارة حساس التردد أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة حساس التردد",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "ATS / Changeover frequency sensing overheating hot",
],
[
  "ats-043",
  "حساس التردد",
  "حساس التردد يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة حساس التردد تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "ATS / Changeover frequency sensing intermittent unstable",
],
[
  "ats-044",
  "حساس التردد",
  "حساس التردد بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ حساس التردد.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "ATS / Changeover frequency sensing loose wrong connection",
],
[
  "ats-045",
  "حساس التردد",
  "قراءة أو خرج حساس التردد مو طبيعي",
  "قراءة أو خرج حساس التردد أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "ATS / Changeover frequency sensing abnormal reading output",
],
[
  "ats-046",
  "Timer تأخير التحويل",
  "Timer تأخير التحويل ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة Timer تأخير التحويل متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة Timer تأخير التحويل",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "ATS / Changeover transfer timer not working open",
],
[
  "ats-047",
  "Timer تأخير التحويل",
  "حرارة Timer تأخير التحويل ترتفع",
  "حرارة Timer تأخير التحويل أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة Timer تأخير التحويل",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "ATS / Changeover transfer timer overheating hot",
],
[
  "ats-048",
  "Timer تأخير التحويل",
  "Timer تأخير التحويل يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة Timer تأخير التحويل تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "ATS / Changeover transfer timer intermittent unstable",
],
[
  "ats-049",
  "Timer تأخير التحويل",
  "Timer تأخير التحويل بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ Timer تأخير التحويل.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "ATS / Changeover transfer timer loose wrong connection",
],
[
  "ats-050",
  "Timer تأخير التحويل",
  "قراءة أو خرج Timer تأخير التحويل مو طبيعي",
  "قراءة أو خرج Timer تأخير التحويل أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "ATS / Changeover transfer timer abnormal reading output",
],
[
  "ats-051",
  "Timer تأخير الرجوع",
  "Timer تأخير الرجوع ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة Timer تأخير الرجوع متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة Timer تأخير الرجوع",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "ATS / Changeover retransfer timer not working open",
],
[
  "ats-052",
  "Timer تأخير الرجوع",
  "حرارة Timer تأخير الرجوع ترتفع",
  "حرارة Timer تأخير الرجوع أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة Timer تأخير الرجوع",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "ATS / Changeover retransfer timer overheating hot",
],
[
  "ats-053",
  "Timer تأخير الرجوع",
  "Timer تأخير الرجوع يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة Timer تأخير الرجوع تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "ATS / Changeover retransfer timer intermittent unstable",
],
[
  "ats-054",
  "Timer تأخير الرجوع",
  "Timer تأخير الرجوع بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ Timer تأخير الرجوع.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "ATS / Changeover retransfer timer loose wrong connection",
],
[
  "ats-055",
  "Timer تأخير الرجوع",
  "قراءة أو خرج Timer تأخير الرجوع مو طبيعي",
  "قراءة أو خرج Timer تأخير الرجوع أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "ATS / Changeover retransfer timer abnormal reading output",
],
[
  "ats-056",
  "Timer تبريد المولد",
  "Timer تبريد المولد ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة Timer تبريد المولد متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة Timer تبريد المولد",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "ATS / Changeover cooldown timer not working open",
],
[
  "ats-057",
  "Timer تبريد المولد",
  "حرارة Timer تبريد المولد ترتفع",
  "حرارة Timer تبريد المولد أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة Timer تبريد المولد",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "ATS / Changeover cooldown timer overheating hot",
],
[
  "ats-058",
  "Timer تبريد المولد",
  "Timer تبريد المولد يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة Timer تبريد المولد تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "ATS / Changeover cooldown timer intermittent unstable",
],
[
  "ats-059",
  "Timer تبريد المولد",
  "Timer تبريد المولد بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ Timer تبريد المولد.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "ATS / Changeover cooldown timer loose wrong connection",
],
[
  "ats-060",
  "Timer تبريد المولد",
  "قراءة أو خرج Timer تبريد المولد مو طبيعي",
  "قراءة أو خرج Timer تبريد المولد أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "ATS / Changeover cooldown timer abnormal reading output",
],
[
  "ats-061",
  "Interlock كهربائي",
  "Interlock كهربائي ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة Interlock كهربائي متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة Interlock كهربائي",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "ATS / Changeover electrical interlock not working open",
],
[
  "ats-062",
  "Interlock كهربائي",
  "حرارة Interlock كهربائي ترتفع",
  "حرارة Interlock كهربائي أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة Interlock كهربائي",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "ATS / Changeover electrical interlock overheating hot",
],
[
  "ats-063",
  "Interlock كهربائي",
  "Interlock كهربائي يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة Interlock كهربائي تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "ATS / Changeover electrical interlock intermittent unstable",
],
[
  "ats-064",
  "Interlock كهربائي",
  "Interlock كهربائي بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ Interlock كهربائي.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "ATS / Changeover electrical interlock loose wrong connection",
],
[
  "ats-065",
  "Interlock كهربائي",
  "قراءة أو خرج Interlock كهربائي مو طبيعي",
  "قراءة أو خرج Interlock كهربائي أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "ATS / Changeover electrical interlock abnormal reading output",
],
[
  "ats-066",
  "Interlock ميكانيكي",
  "Interlock ميكانيكي ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة Interlock ميكانيكي متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة Interlock ميكانيكي",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "ATS / Changeover mechanical interlock not working open",
],
[
  "ats-067",
  "Interlock ميكانيكي",
  "حرارة Interlock ميكانيكي ترتفع",
  "حرارة Interlock ميكانيكي أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة Interlock ميكانيكي",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "ATS / Changeover mechanical interlock overheating hot",
],
[
  "ats-068",
  "Interlock ميكانيكي",
  "Interlock ميكانيكي يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة Interlock ميكانيكي تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "ATS / Changeover mechanical interlock intermittent unstable",
],
[
  "ats-069",
  "Interlock ميكانيكي",
  "Interlock ميكانيكي بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ Interlock ميكانيكي.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "ATS / Changeover mechanical interlock loose wrong connection",
],
[
  "ats-070",
  "Interlock ميكانيكي",
  "قراءة أو خرج Interlock ميكانيكي مو طبيعي",
  "قراءة أو خرج Interlock ميكانيكي أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "ATS / Changeover mechanical interlock abnormal reading output",
],
[
  "ats-071",
  "Neutral Pole",
  "Neutral Pole ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة Neutral Pole متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة Neutral Pole",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "ATS / Changeover switched neutral not working open",
],
[
  "ats-072",
  "Neutral Pole",
  "حرارة Neutral Pole ترتفع",
  "حرارة Neutral Pole أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة Neutral Pole",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "ATS / Changeover switched neutral overheating hot",
],
[
  "ats-073",
  "Neutral Pole",
  "Neutral Pole يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة Neutral Pole تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "ATS / Changeover switched neutral intermittent unstable",
],
[
  "ats-074",
  "Neutral Pole",
  "Neutral Pole بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ Neutral Pole.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "ATS / Changeover switched neutral loose wrong connection",
],
[
  "ats-075",
  "Neutral Pole",
  "قراءة أو خرج Neutral Pole مو طبيعي",
  "قراءة أو خرج Neutral Pole أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "ATS / Changeover switched neutral abnormal reading output",
],
[
  "ats-076",
  "قاطع المصدر الرئيسي",
  "قاطع المصدر الرئيسي ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة قاطع المصدر الرئيسي متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة قاطع المصدر الرئيسي",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "ATS / Changeover mains breaker not working open",
],
[
  "ats-077",
  "قاطع المصدر الرئيسي",
  "حرارة قاطع المصدر الرئيسي ترتفع",
  "حرارة قاطع المصدر الرئيسي أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة قاطع المصدر الرئيسي",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "ATS / Changeover mains breaker overheating hot",
],
[
  "ats-078",
  "قاطع المصدر الرئيسي",
  "قاطع المصدر الرئيسي يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة قاطع المصدر الرئيسي تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "ATS / Changeover mains breaker intermittent unstable",
],
[
  "ats-079",
  "قاطع المصدر الرئيسي",
  "قاطع المصدر الرئيسي بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ قاطع المصدر الرئيسي.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "ATS / Changeover mains breaker loose wrong connection",
],
[
  "ats-080",
  "قاطع المصدر الرئيسي",
  "قراءة أو خرج قاطع المصدر الرئيسي مو طبيعي",
  "قراءة أو خرج قاطع المصدر الرئيسي أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "ATS / Changeover mains breaker abnormal reading output",
],
[
  "ats-081",
  "قاطع المولد",
  "قاطع المولد ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة قاطع المولد متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة قاطع المولد",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "ATS / Changeover generator breaker not working open",
],
[
  "ats-082",
  "قاطع المولد",
  "حرارة قاطع المولد ترتفع",
  "حرارة قاطع المولد أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة قاطع المولد",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "ATS / Changeover generator breaker overheating hot",
],
[
  "ats-083",
  "قاطع المولد",
  "قاطع المولد يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة قاطع المولد تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "ATS / Changeover generator breaker intermittent unstable",
],
[
  "ats-084",
  "قاطع المولد",
  "قاطع المولد بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ قاطع المولد.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "ATS / Changeover generator breaker loose wrong connection",
],
[
  "ats-085",
  "قاطع المولد",
  "قراءة أو خرج قاطع المولد مو طبيعي",
  "قراءة أو خرج قاطع المولد أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "ATS / Changeover generator breaker abnormal reading output",
],
[
  "ats-086",
  "Remote Start للمولد",
  "Remote Start للمولد ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة Remote Start للمولد متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة Remote Start للمولد",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "ATS / Changeover generator remote start not working open",
],
[
  "ats-087",
  "Remote Start للمولد",
  "حرارة Remote Start للمولد ترتفع",
  "حرارة Remote Start للمولد أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة Remote Start للمولد",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "ATS / Changeover generator remote start overheating hot",
],
[
  "ats-088",
  "Remote Start للمولد",
  "Remote Start للمولد يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة Remote Start للمولد تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "ATS / Changeover generator remote start intermittent unstable",
],
[
  "ats-089",
  "Remote Start للمولد",
  "Remote Start للمولد بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ Remote Start للمولد.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "ATS / Changeover generator remote start loose wrong connection",
],
[
  "ats-090",
  "Remote Start للمولد",
  "قراءة أو خرج Remote Start للمولد مو طبيعي",
  "قراءة أو خرج Remote Start للمولد أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "ATS / Changeover generator remote start abnormal reading output",
],
[
  "ats-091",
  "مؤشرات ATS",
  "مؤشرات ATS ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة مؤشرات ATS متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة مؤشرات ATS",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "ATS / Changeover ats indication not working open",
],
[
  "ats-092",
  "مؤشرات ATS",
  "حرارة مؤشرات ATS ترتفع",
  "حرارة مؤشرات ATS أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة مؤشرات ATS",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "ATS / Changeover ats indication overheating hot",
],
[
  "ats-093",
  "مؤشرات ATS",
  "مؤشرات ATS يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة مؤشرات ATS تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "ATS / Changeover ats indication intermittent unstable",
],
[
  "ats-094",
  "مؤشرات ATS",
  "مؤشرات ATS بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ مؤشرات ATS.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "ATS / Changeover ats indication loose wrong connection",
],
[
  "ats-095",
  "مؤشرات ATS",
  "قراءة أو خرج مؤشرات ATS مو طبيعي",
  "قراءة أو خرج مؤشرات ATS أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "ATS / Changeover ats indication abnormal reading output",
],
[
  "ats-096",
  "Manual / Auto Selector",
  "Manual / Auto Selector ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة Manual / Auto Selector متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة Manual / Auto Selector",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "ATS / Changeover ats manual auto not working open",
],
[
  "ats-097",
  "Manual / Auto Selector",
  "حرارة Manual / Auto Selector ترتفع",
  "حرارة Manual / Auto Selector أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة Manual / Auto Selector",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "ATS / Changeover ats manual auto overheating hot",
],
[
  "ats-098",
  "Manual / Auto Selector",
  "Manual / Auto Selector يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة Manual / Auto Selector تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "ATS / Changeover ats manual auto intermittent unstable",
],
[
  "ats-099",
  "Manual / Auto Selector",
  "Manual / Auto Selector بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ Manual / Auto Selector.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "ATS / Changeover ats manual auto loose wrong connection",
],
[
  "ats-100",
  "Manual / Auto Selector",
  "قراءة أو خرج Manual / Auto Selector مو طبيعي",
  "قراءة أو خرج Manual / Auto Selector أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("إعدادات التحويل أو الفولت والتردد مو صحيحة", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "ATS / Changeover ats manual auto abnormal reading output",
],
];

export const atsFaults: AtsFault[] = rows.map(
  ([
    id,
    device_ar,
    name_ar,
    description_ar,
    symptom,
    causes,
    solutions,
    severity,
    keywords,
  ]) => {
    const critical = severity === "حرجة";

    return {
      id,
      category_id: null,
      device_ar,
      name_ar,
      description_ar,
      symptoms: [symptom],
      causes,
      tests: [
        {
          test: "الفحص الأولي",
          location: device_ar,
          method: "اعزل المصدر الرئيسي والمصدر الاحتياطي معاً قبل فتح ATS. لا تتجاوز interlock ولا تشغل الكونتاكتورات باليد تحت الجهد لأن ممكن يصير ربط بين مصدرين.",
          normal:
            "القراءات والحرارة والتوصيلات ضمن الطبيعي، وماكو حرك أو تسريب أو تقطيع أو تلف واضح.",
          faulty:
            "حرارة عالية أو فصل متكرر أو ربط مرخي أو قراءة غير طبيعية يدل على عطل يحتاج فحص قبل التشغيل.",
        },
      ],
      solutions,
      severity,
      safety_warnings: critical
        ? [
            "تنبيه: اعزل كل مصادر الطاقة قبل الصيانة وانتبه من التغذية الراجعة أو التشغيل الأوتوماتيكي.",
            "العمل أو القياس على أجزاء حية أو جهد عالي خليه لفني مؤهل وبمعدات مناسبة.",
          ]
        : [
            "افصل وعزل التغذية قبل الفك أو إعادة الربط.",
            "إذا شفت شرر أو ذوبان أو ريحة حرك أو تشغيل غير متوقع، وقف المعدة وخلي فني يفحصها.",
          ],
      error_code: null,
      keywords,
      next_question_key: null,
    };
  },
);
